import Lookup from 'src/componentes/select2';

const TipoPeriodicidadePontoControle = ({
  clearable = false,
  required = false,
  ...rest
}) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TipoPeriodicidadePontoControleLookup"
    clearable={clearable}
    required={required}
    {...rest}
  />
);

export default TipoPeriodicidadePontoControle;
